import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { taskKeys } from '@core/react-query/features/tasks/task'
import { tasksKeys } from '@core/react-query/features/tasks/tasks'
import { useRealTimeSubscription } from '@core/providers/useRealTimeSubscription'
import { PusherOptions } from '@core/providers/usePusher'

export const useRealTimeTask = (taskId: number, options?: PusherOptions) => {
  const { channel, bindEventHandler } = useRealTimeSubscription(
    `private-task.${taskId}`,
    options,
  )
  const queryClient = useQueryClient()

  useEffect(() => {
    bindEventHandler('task.updated', (data) => {
      const queryKey = taskKeys.byId({ taskId }).queryKey
      queryClient.invalidateQueries(queryKey)

      // Invalidate task list queries so the list view reflects the updated status
      queryClient.invalidateQueries({ queryKey: tasksKeys.allTasks._def })
      queryClient.invalidateQueries({ queryKey: tasksKeys.myTasks._def })
    })
  }, [channel])
}
